import { apiClient } from "../../../base/ApiClient";


export const getSystemSettings = async () => {
  const response = await apiClient.get('/core/settings/current/');
  return response.data;
};

export const updateSystemSettings = async (data) => {
  const response = await apiClient.patch('/core/settings/update_settings/', data);
  return response.data;
};